<template>
  <div class="box">
    <div id="hardhome" class="harhome-box"  style="position: relative">
      <div class="banner-bg">
        <div class="banner">
          <h2>智能硬件平台</h2>
          <p class="tip">完全开放SDK能力与云端能力</p>
          <!--<router-link to="/createPro">-->
            <el-button type="primary" class="to-sdk" round @click="routeCreatePro">立即接入SDK <span style="top: -3px;">&rarr;</span></el-button>
          <!--</router-link>-->
          <router-link to="/tutor/yjjrgl">
            <p class="to-doc"><a href="javascript:;">查看文档</a></p>
          </router-link>
        </div>
      </div>
      <div class="bg-bottom-box">
        <div class="sbg">
        <div class="sCon">
        <span class="sc1" @click="navClick($event)"></span>
        <span class="sc2" @click="navClick($event)"></span>
        <span class="sc3" @click="navClick($event)"></span>
        <span class="sc4" @click="navClick($event)"></span>
        </div>
        </div>
      </div>
      <section class="section-1">
        <div class="section-content">
          <h2 class="title">开发者认证</h2>
          <p class="title-tip">开发者可以通过OrionOS硬件接入集成语音交互引擎，<br/>在产品集成SDK前需要经过开发者认证并通过审核后才能使用</p>
          <ul class="se-1-ul">
            <div class="ell-box"></div>
            <li class="li-m-r">
              <div class="bg bg-1"></div>
              <p class="success">提交认证材料</p>
              <p class="default">提交个人或企业基本信息<br/>认证开发者身份</p>
             <!-- <router-link to="/developer">-->
                <el-button type="primary" class="se-to-1" round  @click="approveRoute">立即认证</el-button>
            <!--  </router-link>-->
            </li>
            <li class="li-m-r">
              <div class="bg bg-2"></div>
              <p class="success">审核通过</p>
              <p class="default">开放平台运营中心<br/>极速审核</p>
              <el-button type="primary" class="se-to-1" round  @click="approveRoute">查看进展</el-button>
            </li>
            <li>
              <div class="bg bg-3"></div>
              <p class="success">接入OS</p>
              <p class="default">赋能硬件即刻接入<br/>语音交互引擎</p>
              <router-link to="/tutor/yjjrgl">
                <el-button type="primary" class="se-to-1" round>查看文档</el-button>
              </router-link>
            </li>
          </ul>
        </div>
      </section>
      <section class="section-2">
        <div class="section-content">
          <h2 class="title">三大主流平台，标准SDK接入</h2>
          <p class="title-tip">猎户语音OS为智能设备开发者提供了主流设备的兼容与适配。<br/>Android，Linux，freeRTOS快速标准化接入</p>
          <ul class="se-2-ul">
            <li>
              <div class="bg bg-1"></div>
              <p class="se-2-p-small">LINUX</p>
              <p class="se-2-p-big">跨平台适应</p>
              <router-link to="/tutor/LSDK">
                <a href="#" class="se-2-a">了解详情</a>
              </router-link>
            </li>
            <li>
              <div class="bg bg-2"></div>
              <p class="se-2-p-small">ANDROID</p>
              <p class="se-2-p-big">生态体系健全</p>
              <router-link to="/tutor/ASDK">
                <a href="#" class="se-2-a">了解详情</a>
              </router-link>
            </li>
            <li>
              <div class="bg bg-3"></div>
              <p class="se-2-p-small">RTOS</p>
              <p class="se-2-p-big">低成本</p>
              <router-link to="/tutor/FSDK">
                <a href="#" class="se-2-a">了解详情</a>
              </router-link>
            </li>
          </ul>
        </div>
      </section>
      <section class="section-3">
        <div class="section-content">
          <h2 class="title">添加云端技能</h2>
          <p class="title-tip">开发者可以通过技能商店添加语音交互技能，为智能设备创造更丰富的交互能力</p>
        </div>
      </section>
      <section class="section-4">
        <div class="section-content">
          <h2 class="title">接入OS</h2>
          <p class="title-tip">猎户语音OS已与小米、美的、猎豹移动、喜马拉雅、锤子科技、搜狗AI开放平台、富士康、易视腾<br/>等厂商达成深度合作，并共同研制出多款行业成功产品。</p>
          <ul class="se-4-ul">
            <li class="li-1"></li>
            <li class="li-2"></li>
            <li class="li-3"></li>
            <li class="li-4"></li>
            <li class="li-6"></li>
            <li class="li-5"></li>
          </ul>
          <p class="wait-not">还在等什么?</p>
          <!--<router-link to="/createPro">-->
            <el-button type="primary" class="se-4-to" round @click="routeCreateProlist">立即接入OS</el-button>
          <!--</router-link>-->
         <!-- <router-link to="tutor/ptjj">-->

            <p><a href="javascript:;" class="se-4-a" @click="routeSkillWord">查看技术文档</a></p>
         <!-- </router-link>-->
        </div>
      </section>
      <footer>
        <div class="footer">
            <p style="clear: both;margin-bottom: 7px"><span class="pull-left">邮箱: bd@ainirobot.com&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  地址: 北京朝阳区三里屯盈科中心C座三层</span> <span class="pull-right">技能开发QQ群:702087131</span></p>
            <p style="clear: both"><span class="pull-left">京ICP备17016764号-1&nbsp;&copy;<span>{{ new Date().getFullYear()-1 }}</span>-<span>{{ new Date().getFullYear() }}</span>&nbsp;&nbsp;&nbsp;&nbsp;猎户星空版权所有</span> <span class="pull-right">硬件接入QQ群:702108481</span></p>
        </div>
      </footer>

      <ul class="nav-right">
        <li @click="navClick($event)">开发者认证</li>
        <li @click="navClick($event)">选择平台</li>
        <li @click="navClick($event)">云端配置</li>
        <li @click="navClick($event)">接入OS</li>
      </ul>
    </div>

  </div>

</template>
<script>
  import {examineApi} from '@/api'
  export default {
    data() {
      return {
        isPass: 0,
        userPhone: '',
        isLogin: false
      }
    },
    mounted() {
      this.setPhone();
      this.reloadSee();
      $('.box').on('scroll','', this.scrollEvent);
      this.goTop();
      this.setWidth();
    },
    created () {
         this.examine();
    },
    methods: {
      getCookie (name){
        if (document.location.host == 'opentw.ainirobot.com') {
            name = name + '_tw'
        }
        let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)")
        if(arr=document.cookie.match(reg)) {
          return arr[2]
        } else {
          return null;
        }
      },
      setWidth(){
        let _body = $('#app').width();
        let _header = $('#hardhome').width();
        let _w = Number(_body) - Number(_header)
//        console.log(_w);
        $('#header').css('paddingRight',_w);
      },
      async examine () {
        let res = await examineApi()
        if (!res) return
        if (res.data.code == 200) {
          if (res.data.data.user_type) {
            this.isPass = res.data.data.status;
            //console.log(res.data);
          }
        }
      },
      routeCreatePro () {
        this.$store.dispatch('changeWhere','product');
        let phone = this.getCookie('userTel');
//        console.log("我的手机号码是："+phone)
        if(phone == ""){
          this.$router.push('/login');
        }else{
          // 立即接入sdk
          this.$router.push('/productList')
        }

      },
      routeCreateProlist(){
        let phone = this.getCookie('userTel');
//        console.log("我的手机号码是："+phone)
        if(phone == ""){
          this.$router.push('/login');
        }else{
          // 立即接入sdk
          this.$router.push('/productList')
        }

      },
      routeSkillWord(){
        //alert(1)
        this.$router.push('tutor/ptjj')

      },
      approveRoute(){
        let phone = this.getCookie('userTel');
//        console.log("我的手机号码是："+phone)
        if(phone == ""){
          this.$router.push('/login');
        }else{
          // 立即接入开发者认证
          this.$router.push('/developer')
        }
      },

      goTop(){
        setTimeout(function () {
          $("html,body").animate({scrollTop: 0}, 0);
        },0)
      },
      toLogin(){
        this.$router.push('/login');
      },
      setPhone() {
        let phone = this.getCookie('userTel');
        if (phone) {
          this.userPhone = phone;
          this.isLogin = true;
        } else {
          this.isLogin = false;
        }
      },
      // getCookie(cname) {
      //   if (document.location.host == 'opentw.ainirobot.com') {
      //       name = name + '_tw'
      //   }
      //   var name = cname + "=";
      //   var ca = document.cookie.split(';');
      //   for (var i = 0; i < ca.length; i++) {
      //     var c = ca[i];
      //     while (c.charAt(0) == ' ') c = c.substring(1);
      //     if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
      //   }
      //   return "";
      // },
      // removeCookie(name) {
      //   if (document.location.host == 'opentw.ainirobot.com') {
      //       name = name + '_tw'
      //   }
      //   let exp = new Date();
      //   exp.setTime(exp.getTime() - 1);
      //   let cval = this.getCookie(name);
      //   if (cval != null)
      //     document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
      // },
      // outLogin() {
      //   this.removeCookie('token')
      //   this.removeCookie('userTel')
      //   this.setPhone();
      //   this.$router.push('/login')
      // },
      reloadSee(){
        let st = $('.box').scrollTop();
        if($('.box').scrollTop()<720){
          $('#header-copy').stop().fadeOut(100);
        }else{
          $('#header-copy').stop().fadeIn(100);
        }

        if($('.box').scrollTop()<780){
          this.$store.dispatch('changeF')
        }else{
          this.$store.dispatch('changeT')
        }
      },
      scrollEvent() {
        let st = $('.box').scrollTop()+100;
        let arr = [];
        let ele = $('section');
        for(let i = 0;i <ele.length ;i++){
          arr.push($('section').eq(i).position().top - 90);
        }
        if(arr[0]<st && st<arr[1]){
          $('.nav-right li').removeClass('active').eq(0).addClass('active');
        }else if(arr[1]<st && st<arr[2]){
          $('.nav-right li').removeClass('active').eq(1).addClass('active');
        }else if(arr[2]<st && st<arr[3]){
          $('.nav-right li').removeClass('active').eq(2).addClass('active');
        }else if(st > arr[3]){
          $('.nav-right li').removeClass('active').eq(3).addClass('active');
        }
        if(630> $('.box').scrollTop()){
          $('.nav-right').fadeOut();
        }else{
          $('.nav-right').fadeIn();
        }
        if($('.box').scrollTop()<780){
          this.$store.dispatch('changeF')
        }else{
          this.$store.dispatch('changeT')
        }
      },
      navClick(e) {
        let index = $(e.target).index()
        let targetScroll = $('section').eq(index).position().top;
        $('.box').animate({scrollTop: targetScroll}, 300);
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss">
  .box{
    height: 100%;
    overflow-y: auto;
  }
  .harhome-box {
    margin-top:60px;
    .banner-bg {
      margin-top:60px;
      background: url("../../../static/images/hard/banner-bg.jpg") center;
      background-size: cover;
      min-width: 1022px;
      height: 620px;
    }
    .banner {
      width: 1022px;
      margin: 0 auto;
      padding: 190px 60px 0;
      h2 {
        font-size: 60px;
        color: #fff;
      }
      .tip {
        font-size: 28px;
        margin-top: 10px;
        color: #fff;
        font-weight: 100;
      }
      .to-sdk {
        width: 280px;
        height: 60px;
        font-size: 22px;
        margin-top: 60px;
        margin-bottom: 20px;
        margin-left: 40px;
        color: #fff;
        border-radius: 30px;
        span {
          position: relative;
        }
      }
      .to-doc {
        width: 280px;
        text-align: center;
        margin-left: 40px;
        a {
          color: #fff;
          font-size: 16px;
          line-height: 20px;
          &:hover {
            color: #fff;

          }
        }
      }
    }
    .bg-bottom-box {
      min-width: 1022px;
      height: 60px;
      background: #000;
      .sbg {
        height: 60px;
        background-color: #000;
        background: url(../../../static/images/sbg.png) no-repeat center #000;
        .sCon {
          width: 1018px;
          margin: 0 auto;
          height: 100%;
          padding-left: 305px;
          span {
            display: inline-block;
            cursor: pointer;
          }
          .sc1 {
            height: 100%;
            width: 160px;
          }
          .sc2 {
            height: 100%;
            width: 190px;
          }
          .sc3 {
            height: 100%;
            width: 190px;
          }
          .sc4 {
            height: 100%;
            width: 161px;
          }
        }
      }
    }
    section {
      min-width: 1022px;
      background: #fff;
    }
    .title {
      font-size: 30px;
      margin-top: 0;
      text-align: center;
      color: #000;
      padding: 80px 0 15px;
    }
    .title-tip {
      font-size: 16px;
      color: #000;
      line-height: 30px;
      text-align: center;
    }
    .section-1 {
      .section-content {
        width: 1022px;
        margin: 0 auto;
        height: 640px;
      }

      .se-1-ul {
        overflow: hidden;
        padding-left: 60px;
        position: relative;
        margin-top: 80px;
        background: url("../../../static/images/hard/ellipsis.png") no-repeat 300px 162px;
        .ell-box {
          width: 74px;
          height: 6px;
          background: url("../../../static/images/hard/ellipsis.png") no-repeat center;
          position: absolute;
          right: 312px;
          top: 162px;
        }
        li {
          list-style: none;
          float: left;
          width: 215px;
          border: 1px solid #077eec;
          border-radius: 20px;
          text-align: center;
          .bg {
            height: 145px;
            width: 100%;
          }
          .bg-1 {
            background: url("../../../static/images/hard/section-1-l.png") no-repeat center;
          }
          .bg-2 {
            background: url("../../../static/images/hard/section-1-c.png") no-repeat center;
          }
          .bg-3 {
            background: url("../../../static/images/hard/section-1-r.png") no-repeat center;
          }
          .success {
            color: #077eec;
            font-weight: 400;
          }
          .default {
            color: #000;
            font-weight: 400;
          }
          .se-to-1 {
            color: #fff;
            margin-top: 35px;
            margin-bottom: 30px;
            width: 110px;
            padding-top: 7px;
            padding-bottom: 7px;
          }
          .empty {
            height: 95px;
          }
        }
        .li-m-r {
          margin-right: 122px;
        }
      }
    }
    .section-2 {
      background: #f8f8f8;
      .section-content {
        width: 1022px;
        margin: 0 auto;
        height: 700px;
      }
      .se-2-ul {
        overflow: hidden;
        width: 900px;
        margin: 35px auto 0;
        li {
          width: 300px;
          height: 400px;
          float: left;
          list-style: none;
          transition: all 0.2s;
          background: #f8f8f8;
          text-align: center;
          &:hover {
            background: #fff;
          }
          .bg {
            height: 220px;
          }
          .bg-1 {
            background: url("../../../static/images/hard/se-2-bg-l.png") no-repeat center;
          }
          .bg-2 {
            background: url("../../../static/images/hard/se-2-bg-c.png") no-repeat center;
          }
          .bg-3 {
            background: url("../../../static/images/hard/se-2-bg-r.png") no-repeat center;
          }
          &:hover {
            .se-2-a {
              display: block;
              margin: 0 auto;
            }
          }
        }
        .se-2-p-small {
          font-size: 16px;
          margin-bottom: -5px;
          color: #000;
        }
        .se-2-p-big {
          font-size: 24px;
          color: #000;
        }
        .se-2-a {
          margin-top: 30px;
          width: 90%;
          display: none;
          color: #077eec;
        }
      }
    }
    .section-3 {
      .section-content {
        width: 1022px;
        margin: 0 auto;
        height: 700px;
        background: #fff;
        background: url("../../../static/images/hard/se-3-bg.jpg") no-repeat center bottom;
      }
    }
    .section-4 {
      background: #f8f8f8;
      .section-content {
        width: 1022px;
        margin: 0 auto;
        height: 700px;
        text-align: center;
      }
      .se-4-ul {
        overflow: hidden;
        text-align: center;
        padding: 80px 0 70px;
        li {
          width: 93px;
          height: 93px;
          border-radius: 10px;
          display: inline-block;
          margin-right: 40px;
          list-style: none;
          background-size: cover;
        }
        .li-1 {
          background: url("../../../static/images/hard/se-4-1.png") no-repeat center;
        }
        .li-2 {
          background: url("../../../static/images/hard/se-4-2.png") no-repeat center;
        }
        .li-3 {
          background: url("../../../static/images/hard/se-4-3.png") no-repeat center;
        }
        .li-4 {
          background: url("../../../static/images/hard/se-4-4.png") no-repeat center;
        }
        .li-5 {
          background: url("../../../static/images/hard/se-4-5.png") no-repeat center;
          margin-right: 0px;
        }
        .li-6 {
          background: url("../../../static/images/hard/se-4-6.png") no-repeat center;
        }
      }
      .wait-not {
        font-size: 34px;
        margin-bottom: 0px;
        color: #077eec;
      }
      .se-4-to {
        width: 300px;
        margin: 20px auto 15px;
        font-size: 26px;
        border-radius: 30px;
        height: 60px;
      }
      .se-4-a {
        color: #077eec;
      }
    }
    .nav-right {
      position: fixed;
      z-index: 100;
      width: 90px;
      right: 50%;
      top: 180px;
      display: none;
      transform: translate(600px, 0);
      border-left: 1px solid #e0e0e0;
      li {
        color: #000;
        list-style: none;
        font-size: 14px;
        padding: 15px 5px;
        border-left: 1px solid #e0e0e0;
        cursor: pointer;
        &:hover, &.active {
          border-left: 1px solid #077eec;
          color: #077eec;
        }
      }
    }


    footer{
      width: 100%;
      height: 95px;
      background: #191919;
      .footer{
        width: 1150px;
        margin: 0 auto;
        color: #79878a;
        font-size: 12px;
        padding-top: 30px;
        p{
          overflow: hidden;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/hardware/Hardhome.vue